import { render } from "./DeviceAssignInstanceDialog.vue?vue&type=template&id=039a40aa"
import script from "./DeviceAssignInstanceDialog.vue?vue&type=script&lang=js"
export * from "./DeviceAssignInstanceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__